import { gql } from "@urql/svelte";

export const Sponsors = gql`
    query SponsorQuery($congressId: Int, $widgetView: String) {
        sponsordata(congressId: $congressId, widgetView: $widgetView) {
            congressYear
            congressDay1
            congressDay2
            congressMonth1
            congressMonth2
            loungenplanUrl
            sponsoreninfotext
            sponsors {
                ausstellerId
                firmenname_IMK_AV
                imk_logo_online_filename
                isPremium
                hasDetails
                detailcontent
                av_telefon
                av_fax
                av_plz
                av_ort
                av_strasse
                av_email
                av_url
                av_url2
                av_titel1
                av_nachname1
                av_vorname1
                av_position1
                ansprechpartner1_filename
                ansprechpartner1_titel
                av_titel2
                av_nachname2
                av_vorname2
                av_position2
                ansprechpartner2_filename
                ansprechpartner2_titel
                av_titel3
                av_nachname3
                av_vorname3
                av_position3
                ansprechpartner3_filename
                ansprechpartner3_titel
                av_titel4
                av_nachname4
                av_vorname4
                av_position4
                ansprechpartner4_filename
                ansprechpartner4_titel
                portrait_online_html
                WSLinkVID
                GGLinkVID
                O2OLinkVID
            }
        }
    }
`;
export const Starvortraege = gql`
    query StarvortraegeQuery($congressId: Int, $widgetView: String) {
        starvortraegedata(congressId: $congressId, widgetView: $widgetView) {
            congressYear
            congressDay1
            congressDay2
            congressMonth1
            congressMonth2
            anmeldestop
            cfaTextsteuerung
            eventlist {
                veranstaltungId
                typ
                startDate
                startTime
                endTime
                location
                eventTitle
                eventDescription
                eventDescription2
                eventDescription3
                referent1name
                referent1company
                referent1position
                referent1resume
                referent1image
                referent1imageTitle
                referent2name
                referent2company
                referent2position
                referent2resume
                referent2image
                referent2imageTitle
                cfa_certified
                ausstellerId
                avCompanyname
                haveAVPortrait
                eventAttachment {
                    filename
                    title
                }
            }
        }
    }
`;
export const Fruehstuecksworkshop = gql`
    query FruehstuecksworkshopQuery($congressId: Int, $widgetView: String) {
        fruehstuecksworkshopdata(congressId: $congressId, widgetView: $widgetView) {
            congressYear
            congressDay1
            congressDay2
            congressMonth1
            congressMonth2
            anmeldestop
            cfaTextsteuerung
            title
            headdescription
            logoblock
            eventlist {
                veranstaltungId
                typ
                typName
                startDate
                startTime
                endTime
                location
                eventTitle
                eventDescription
                eventDescription2
                eventDescription3
                referentCount
                referent1name
                referent1company
                referent1position
                referent1resume
                referent1image
                referent1imageTitle
                referent2name
                referent2company
                referent2position
                referent2resume
                referent2image
                referent2imageTitle
                referent3name
                referent3company
                referent3position
                referent3resume
                referent3image
                referent3imageTitle
                referent4name
                referent4company
                referent4position
                referent4resume
                referent4image
                referent4imageTitle
                referent5name
                referent5company
                referent5position
                referent5resume
                referent5image
                referent5imageTitle
                referent6name
                referent6company
                referent6position
                referent6resume
                referent6image
                referent6imageTitle
                cfa_certified
                ausstellerId
                avCompanyname
                haveAVPortrait
                eventAttachment {
                    filename
                    title
                }
                tnHasSeat
                tnSeatAvailable
                tnTimeBlocked
                tnHasWaitinglist
                tnHasKongress
            }
        }
    }
`;
export const IMSpezial = gql`
    query IMSpezialQuery($congressId: Int, $action: String, $actionVeranstaltungId: Int, $widgetView: String) {
        imspezialdata(
            congressId: $congressId
            action: $action
            actionVeranstaltungId: $actionVeranstaltungId
            widgetView: $widgetView
        ) {
            congressYear
            congressDay1
            congressDay2
            congressMonth1
            congressMonth2
            anmeldestop
            startDate
            startTime
            endTime
            eventlist {
                veranstaltungId
                typ
                typName
                startDate
                startTime
                endTime
                location
                eventTitle
                eventDescription
                eventDescription2
                eventDescription3
                referentCount
                referent1name
                referent1company
                referent1position
                referent1resume
                referent1image
                referent1imageTitle
                referent2name
                referent2company
                referent2position
                referent2resume
                referent2image
                referent2imageTitle
                referent3name
                referent3company
                referent3position
                referent3resume
                referent3image
                referent3imageTitle
                referent4name
                referent4company
                referent4position
                referent4resume
                referent4image
                referent4imageTitle
                referent5name
                referent5company
                referent5position
                referent5resume
                referent5image
                referent5imageTitle
                referent6name
                referent6company
                referent6position
                referent6resume
                referent6image
                referent6imageTitle
                cfa_certified
                ausstellerId
                avCompanyname
                haveAVPortrait
                eventAttachment {
                    filename
                    title
                }
                tnHasSeat
                tnSeatAvailable
                tnTimeBlocked
                tnHasWaitinglist
                tnHasKongress
                moderatorSalutatory
            }
        }
    }
`;
export const Wsggo2o = gql`
    query Wsggo2oQuery(
        $congressId: Int
        $widgetView: String
        $filterCategoryId: Int
        $filterAusstellerId: Int
        $filterWs: Int
        $filterGg: Int
        $filterO2o: Int
        $filterDay1: Int
        $filterDay2: Int
        $filterCfa: Int
        $action: String
        $actionVeranstaltungId: Int
        $actionBlocknumber: Int
        $showVeranstaltungId: Int
    ) {
        wsggo2odata(
            congressId: $congressId
            widgetView: $widgetView
            filterCategoryId: $filterCategoryId
            filterAusstellerId: $filterAusstellerId
            filterWs: $filterWs
            filterGg: $filterGg
            filterO2o: $filterO2o
            filterDay1: $filterDay1
            filterDay2: $filterDay2
            filterCfa: $filterCfa
            action: $action
            actionVeranstaltungId: $actionVeranstaltungId
            actionBlocknumber: $actionBlocknumber
            showVeranstaltungId: $showVeranstaltungId
        ) {
            anmeldestop
            anmeldestopO2o
            eventlist {
                veranstaltungId
                terminId
                tnHasKongress
                tnIsModerator
                tnHasSeat
                tnHasWaitinglist
                tnSeatAvailable
                tnTimeBlocked
                o2otimetable {
                    day1Name
                    day2Name
                    day1Statuslist {
                        blocknumber
                        status
                    }
                    day2Statuslist {
                        blocknumber
                        status
                    }
                }
            }
        }
    }
`;
export const Wsggo2obaselist = gql`
    query Wsggo2oBaseQuery(
        $congressId: Int
        $widgetView: String
        $filterCategoryId: Int
        $filterAusstellerId: Int
        $filterWs: Int
        $filterGg: Int
        $filterO2o: Int
        $filterDay1: Int
        $filterDay2: Int
        $filterCfa: Int
        $showVeranstaltungId: Int
    ) {
        wsggo2obaselistdata(
            congressId: $congressId
            widgetView: $widgetView
            filterCategoryId: $filterCategoryId
            filterAusstellerId: $filterAusstellerId
            filterWs: $filterWs
            filterGg: $filterGg
            filterO2o: $filterO2o
            filterDay1: $filterDay1
            filterDay2: $filterDay2
            filterCfa: $filterCfa
            showVeranstaltungId: $showVeranstaltungId
        ) {
            eventlist {
                veranstaltungId
                typ
                startDate
                startTime
                endTime
                location
                eventTitle
                eventDescription
                eventDescription2
                eventDescription3
                referent1name
                referent1company
                referent1position
                referent1resume
                referent1image
                referent1imageTitle
                referent1O2oVeranstaltungId
                referent2name
                referent2company
                referent2position
                referent2resume
                referent2image
                referent2imageTitle
                referent2O2oVeranstaltungId
                cfa_certified
                ausstellerId
                avCompanyname
                haveAVPortrait
                eventAttachment {
                    filename
                    title
                }
                tnHasSeat
                tnIsModerator
                tnSeatAvailable
                tnTimeBlocked
                tnHasWaitinglist
                tnHasKongress
                text1fragenHtml
                text1antwortenHtml
                portraitData {
                    ausstellerId
                    firmenname_IMK_AV
                    imk_logo_online_filename
                    isPremium
                    hasDetails
                    detailcontent
                    av_telefon
                    av_fax
                    av_plz
                    av_ort
                    av_strasse
                    av_email
                    av_url
                    av_url2
                    av_titel1
                    av_nachname1
                    av_vorname1
                    av_position1
                    ansprechpartner1_filename
                    ansprechpartner1_titel
                    av_titel2
                    av_nachname2
                    av_vorname2
                    av_position2
                    ansprechpartner2_filename
                    ansprechpartner2_titel
                    av_titel3
                    av_nachname3
                    av_vorname3
                    av_position3
                    ansprechpartner3_filename
                    ansprechpartner3_titel
                    av_titel4
                    av_nachname4
                    av_vorname4
                    av_position4
                    ansprechpartner4_filename
                    ansprechpartner4_titel
                    portrait_online_html
                    WSLinkVID
                    GGLinkVID
                    O2OLinkVID
                }
                o2otimetable {
                    day1Name
                    day2Name
                    day1Statuslist {
                        blocknumber
                        status
                    }
                    day2Statuslist {
                        blocknumber
                        status
                    }
                }
            }
        }
    }
`;
export const Wsggo2obasedata = gql`
    query Wsggo2oBasedataQuery($congressId: Int, $widgetView: String) {
        wsggo2obasedata(congressId: $congressId, widgetView: $widgetView) {
            congressYear
            congressDay1
            congressDay2
            congressMonth1
            congressMonth2
            anzahlWorkshops
            o2oAnmeldezeitpunkt
            anmeldestop
            anmeldestopO2o
            categoryList {
                categoryId
                categoryName
            }
            sponsorListShort {
                ausstellerId
                companynameIMK
            }
        }
    }
`;
export const Teilnehmerkongresstermine = gql`
    query TeilnehmerkongresstermineQuery(
        $congressId: Int
        $action: String
        $actionVeranstaltungId: Int
        $actionBlocknumber: Int
    ) {
        teilnehmerkongressterminedata(
            congressId: $congressId
            action: $action
            actionVeranstaltungId: $actionVeranstaltungId
            actionBlocknumber: $actionBlocknumber
        ) {
            teilnehmerIsModerator
            eventlistReserved {
                veranstaltungId
                typ
                startDate
                startTime
                endTime
                location
                eventTitle
                eventDescription
                eventDescription2
                eventDescription3
                referent1name
                referent1company
                referent1position
                referent1resume
                referent1image
                referent1imageTitle
                referent1O2oVeranstaltungId
                referent2name
                referent2company
                referent2position
                referent2resume
                referent2image
                referent2imageTitle
                referent2O2oVeranstaltungId
                cfa_certified
                ausstellerId
                avCompanyname
                haveAVPortrait
                eventAttachment {
                    filename
                    title
                }
                tnHasSeat
                tnIsModerator
                tnSeatAvailable
                tnTimeBlocked
                tnHasWaitinglist
                tnHasKongress
                text1fragenHtml
                text1antwortenHtml
                portraitData {
                    ausstellerId
                    firmenname_IMK_AV
                    imk_logo_online_filename
                    isPremium
                    hasDetails
                    detailcontent
                    av_telefon
                    av_fax
                    av_plz
                    av_ort
                    av_strasse
                    av_email
                    av_url
                    av_url2
                    av_titel1
                    av_nachname1
                    av_vorname1
                    av_position1
                    ansprechpartner1_filename
                    ansprechpartner1_titel
                    av_titel2
                    av_nachname2
                    av_vorname2
                    av_position2
                    ansprechpartner2_filename
                    ansprechpartner2_titel
                    av_titel3
                    av_nachname3
                    av_vorname3
                    av_position3
                    ansprechpartner3_filename
                    ansprechpartner3_titel
                    av_titel4
                    av_nachname4
                    av_vorname4
                    av_position4
                    ansprechpartner4_filename
                    ansprechpartner4_titel
                    portrait_online_html
                    WSLinkVID
                    GGLinkVID
                    O2OLinkVID
                }
                o2otimetable {
                    day1Name
                    day2Name
                    day1Statuslist {
                        blocknumber
                        status
                    }
                    day2Statuslist {
                        blocknumber
                        status
                    }
                }
                terminId
            }
            eventlistWaiting {
                veranstaltungId
                typ
                startDate
                startTime
                endTime
                location
                eventTitle
                eventDescription
                eventDescription2
                eventDescription3
                referent1name
                referent1company
                referent1position
                referent1resume
                referent1image
                referent1imageTitle
                referent1O2oVeranstaltungId
                referent2name
                referent2company
                referent2position
                referent2resume
                referent2image
                referent2imageTitle
                referent2O2oVeranstaltungId
                cfa_certified
                ausstellerId
                avCompanyname
                haveAVPortrait
                eventAttachment {
                    filename
                    title
                }
                tnHasSeat
                tnIsModerator
                tnSeatAvailable
                tnTimeBlocked
                tnHasWaitinglist
                tnHasKongress
                text1fragenHtml
                text1antwortenHtml
                portraitData {
                    ausstellerId
                    firmenname_IMK_AV
                    imk_logo_online_filename
                    isPremium
                    hasDetails
                    detailcontent
                    av_telefon
                    av_fax
                    av_plz
                    av_ort
                    av_strasse
                    av_email
                    av_url
                    av_url2
                    av_titel1
                    av_nachname1
                    av_vorname1
                    av_position1
                    ansprechpartner1_filename
                    ansprechpartner1_titel
                    av_titel2
                    av_nachname2
                    av_vorname2
                    av_position2
                    ansprechpartner2_filename
                    ansprechpartner2_titel
                    av_titel3
                    av_nachname3
                    av_vorname3
                    av_position3
                    ansprechpartner3_filename
                    ansprechpartner3_titel
                    av_titel4
                    av_nachname4
                    av_vorname4
                    av_position4
                    ansprechpartner4_filename
                    ansprechpartner4_titel
                    portrait_online_html
                    WSLinkVID
                    GGLinkVID
                    O2OLinkVID
                }
                o2otimetable {
                    day1Name
                    day2Name
                    day1Statuslist {
                        blocknumber
                        status
                    }
                    day2Statuslist {
                        blocknumber
                        status
                    }
                }
                terminId
            }
            eventlistModerator {
                veranstaltungId
                typ
                startDate
                startTime
                endTime
                location
                eventTitle
                eventDescription
                eventDescription2
                eventDescription3
                referent1name
                referent1company
                referent1position
                referent1resume
                referent1image
                referent1imageTitle
                referent1O2oVeranstaltungId
                referent2name
                referent2company
                referent2position
                referent2resume
                referent2image
                referent2imageTitle
                referent2O2oVeranstaltungId
                cfa_certified
                ausstellerId
                avCompanyname
                haveAVPortrait
                eventAttachment {
                    filename
                    title
                }
                tnHasSeat
                tnIsModerator
                tnSeatAvailable
                tnTimeBlocked
                tnHasWaitinglist
                tnHasKongress
                text1fragenHtml
                text1antwortenHtml
                portraitData {
                    ausstellerId
                    firmenname_IMK_AV
                    imk_logo_online_filename
                    isPremium
                    hasDetails
                    detailcontent
                    av_telefon
                    av_fax
                    av_plz
                    av_ort
                    av_strasse
                    av_email
                    av_url
                    av_url2
                    av_titel1
                    av_nachname1
                    av_vorname1
                    av_position1
                    ansprechpartner1_filename
                    ansprechpartner1_titel
                    av_titel2
                    av_nachname2
                    av_vorname2
                    av_position2
                    ansprechpartner2_filename
                    ansprechpartner2_titel
                    av_titel3
                    av_nachname3
                    av_vorname3
                    av_position3
                    ansprechpartner3_filename
                    ansprechpartner3_titel
                    av_titel4
                    av_nachname4
                    av_vorname4
                    av_position4
                    ansprechpartner4_filename
                    ansprechpartner4_titel
                    portrait_online_html
                    WSLinkVID
                    GGLinkVID
                    O2OLinkVID
                }
                o2otimetable {
                    day1Name
                    day2Name
                    day1Statuslist {
                        blocknumber
                        status
                    }
                    day2Statuslist {
                        blocknumber
                        status
                    }
                }
                terminId
            }
        }
    }
`;
export const Teilnehmerkongressfeedback = gql`
    query teilnehmerkongressfeedback(
        $congressId: Int
        $action: String
        $feedbackAnwesenheit: Int
        $feedbackLunch: Int
        $feedbackLunchType: Int
        $feedbackLunchTypeOthers: String
        $feedbackAnwesenheitGala: Int
        $feedbackAnwesenheitGettogether: Int
    ) {
        Teilnehmerkongressfeedback(
            congressId: $congressId
            action: $action
            feedbackAnwesenheit: $feedbackAnwesenheit
            feedbackLunch: $feedbackLunch
            feedbackLunchType: $feedbackLunchType
            feedbackLunchTypeOthers: $feedbackLunchTypeOthers
            feedbackAnwesenheitGala: $feedbackAnwesenheitGala
            feedbackAnwesenheitGettogether: $feedbackAnwesenheitGettogether
        ) {
            feedback_entry_locked
            feedback_hasdata
            feedback_hasGettogether
            feedback_anwesenheit
            feedback_mittagessen
            feedback_essenswunsch
            feedback_essenswunsch_sonstiges
            feedback_anwesenheit_galaabend
            feedback_anwesenheit_gettogether
        }
    }
`;
export const Teilnehmerkongresssmsservice = gql`
    query Teilnehmerkongresssmsservice($congressId: Int, $action: String, $sms_status: Int, $sms_nummer: String) {
        Teilnehmerkongresssmsservice(
            congressId: $congressId
            action: $action
            sms_status: $sms_status
            sms_nummer: $sms_nummer
        ) {
            sms_status
            sms_nummer
        }
    }
`;
export const Teilnehmerkongressanmeldung = gql`
    query teilnehmerkongressanmeldung(
        $congressId: Int
        $action: String
        $ansprechperson: String
        $firma: String
        $adresse: String
        $plz: String
        $ort: String
        $land: String
        $email: String
        $telefon: String
        $anmeldeanmerkung: String
        $teilnehmer_anrede: Int
        $teilnehmer_titel: String
        $teilnehmer_vorname: String
        $teilnehmer_nachname: String
        $teilnehmer_firma: String
        $teilnehmer_adresse: String
        $teilnehmer_plz: String
        $teilnehmer_ort: String
        $teilnehmer_land: String
        $teilnehmer_email: String
        $teilnehmer_telefon: String
        $teilnehmer_mobilnummer: String
        $teilnehmer_fax: String
        $teilnehmer_branche: Int
        $teilnehmer_taetigkeit: Int
        $teilnehmer_position: String
        $teilnehmer_taetigkeit_sonstiges: String
    ) {
        Teilnehmerkongressanmeldung(
            congressId: $congressId
            action: $action
            ansprechperson: $ansprechperson
            firma: $firma
            adresse: $adresse
            plz: $plz
            ort: $ort
            land: $land
            email: $email
            telefon: $telefon
            anmeldeanmerkung: $anmeldeanmerkung
            teilnehmer_anrede: $teilnehmer_anrede
            teilnehmer_titel: $teilnehmer_titel
            teilnehmer_vorname: $teilnehmer_vorname
            teilnehmer_nachname: $teilnehmer_nachname
            teilnehmer_firma: $teilnehmer_firma
            teilnehmer_adresse: $teilnehmer_adresse
            teilnehmer_plz: $teilnehmer_plz
            teilnehmer_ort: $teilnehmer_ort
            teilnehmer_land: $teilnehmer_land
            teilnehmer_email: $teilnehmer_email
            teilnehmer_telefon: $teilnehmer_telefon
            teilnehmer_mobilnummer: $teilnehmer_mobilnummer
            teilnehmer_fax: $teilnehmer_fax
            teilnehmer_branche: $teilnehmer_branche
            teilnehmer_taetigkeit: $teilnehmer_taetigkeit
            teilnehmer_position: $teilnehmer_position
            teilnehmer_taetigkeit_sonstiges: $teilnehmer_taetigkeit_sonstiges
        ) {
            congressYear
            congressDay1
            congressDay2
            congressMonth1
            congressMonth2
            branchenlist {
                branchen_id
                branchenname
            }
            isGratis
            ansprechperson
            firma
            adresse
            plz
            ort
            land
            email
            telefon
            anmeldeanmerkung
            teilnehmer_anrede
            teilnehmer_titel
            teilnehmer_vorname
            teilnehmer_nachname
            teilnehmer_firma
            teilnehmer_adresse
            teilnehmer_plz
            teilnehmer_ort
            teilnehmer_land
            teilnehmer_email
            teilnehmer_telefon
            teilnehmer_mobilnummer
            teilnehmer_fax
            teilnehmer_branche
            teilnehmer_taetigkeit
            teilnehmer_position
            teilnehmer_taetigkeit_sonstiges
            userIsLoggedIn
            userHasKongressAnmeldung
            teilnehmerHash
            tid
        }
    }
`;
